<div class="main-content">
  <div class="main-heading">
    <span translate>BUSINESS_REGISTRY</span>
    <div *ngIf="hideNewButton" class="page-actions text-right">
      <a
        *ngIf="canImportBusinesses"
        routerLink="./import"
        class="btn btn-outline-secondary"
      >
        <i class="pi pi-upload" aria-hidden="true"></i>
        <span translate>BUSINESS_IMPORT.ACTION</span>
      </a>
      <a routerLink="./new/details" class="btn btn-success">
        <i class="pi pi-plus"></i>
        <span translate>NEW_BUSINESS</span>
      </a>
    </div>
  </div>
  <div class="card">
    <div class="card-body">
      <div class="table-view">
        <!-- Table starts -->
        <p-table
          #dt
          [tableStyle]="{ 'min-width': '120rem' }"
          [value]="businesses"
          [rows]="paginationRequest.PageSize"
          [paginator]="true"
          [lazy]="true"
          [pageLinks]="5"
          [totalRecords]="totalRecords"
          [rowsPerPageOptions]="[10, 25, 50]"
          [loading]="isLoadingData || isExporting"
          [showCurrentPageReport]="true"
          [sortMode]="'single'"
          [sortField]="paginationRequest.SortColumn"
          [sortOrder]="paginationRequest.SortDirection === 'DESC' ? -1 : 1"
          (onPage)="onPageChange($event)"
          (onSort)="onSort($event)"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
          [alwaysShowPaginator]="true"
        >
          <!-- Caption -->
          <ng-template pTemplate="caption">
            <div class="ui-helper-clearfix">
              <div class="table-options">
                <div class="pull-left">
                  <button
                    class="btn btn-outline-secondary"
                    type="button"
                    (click)="clearFilters()"
                    title="Clear all filters"
                  >
                    <span class="icon ic-sm icon-reset"></span>
                    <span>{{ "CLEAR_FILTERS" | translate }}</span>
                  </button>

                </div>
                <div class="pull-right">
                  <div class="action-btns-group">
                    <kuba-export
                      [reportData]="businesses"
                      [additionalData]="additionalData"
                      [filters]="paginationRequest"
                      [exportAllData]="true"
                      [applicationId]="applicationId"
                      [isPortal]="isPortal"
                      [portalId]="0"
                      [printMode]="additionalData.printMode"
                      (loading)="onExportLoading($event)"
                    ></kuba-export>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
          <!-- Header -->
          <ng-template pTemplate="header">
            <tr>
              <th
                [attr.width]="
                  !isPortal &&
                  isRModeEnabledApp
                    ? '120px'
                    : '60px'
                "
                text-align="center"
              >
                <div
                  *ngIf="
                    !isPortal &&
                    isRModeEnabledApp
                  "
                >
                  {{ "NAVIGATION" | translate }}
                </div>
              </th>

              <th pSortableColumn="CompanyName" width="417px">
                {{ "NAME" | translate }}
                <p-sortIcon field="CompanyName"></p-sortIcon>
              </th>
              <th pSortableColumn="Connectedto" width="200px">
                {{ "CONNECTED_TO" | translate }}
                <p-sortIcon field="Connectedto"></p-sortIcon>
              </th>
              <th pSortableColumn="CategoryName" width="200px">
                {{ "CATEGORY" | translate }}
                <p-sortIcon field="CategoryName"></p-sortIcon>
              </th>
              <th width="120px">
                {{ "LICENSE_MONTH" | translate }}
              </th>
              <th pSortableColumn="EmployeeCount" width="80px">
                {{ "EMP" | translate }}
                <p-sortIcon field="EmployeeCount"></p-sortIcon>
              </th>
              <th pSortableColumn="Status" width="110px">
                {{ "STATUS" | translate }}
                <p-sortIcon field="Status"></p-sortIcon>
              </th>

              <th pSortableColumn="CreatedOn" width="95px">
                {{ "CREATED_ON" | translate }}
                <p-sortIcon field="CreatedOn"></p-sortIcon>
              </th>
              <th pSortableColumn="ModifiedOn" width="95px">
                {{ "MODIFIED_ON" | translate }}
                <p-sortIcon field="ModifiedOn"></p-sortIcon>
              </th>
              <th pSortableColumn="LoginDate" width="95px">
                {{ "LOGIN_DATE" | translate }}
                <p-sortIcon field="LoginDate"></p-sortIcon>
              </th>
              <th pSortableColumn="LoginCount" width="95px">
                {{ "LOGIN_COUNT" | translate }}
                <p-sortIcon field="LoginCount"></p-sortIcon>
              </th>
              <th width="75px">{{ "OPTIONS" | translate }}</th>
            </tr>
            <tr>
              <th></th>
              <th>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="companyNameFilter"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onTextFilterChange('companyName', $any($event.target)?.value)"
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="connectedToFilter"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onTextFilterChange('connectedTo', $any($event.target)?.value)"
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th>
                <input
                  pInputText
                  type="text"
                  [(ngModel)]="categoryNameFilter"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onTextFilterChange('categoryName', $any($event.target)?.value)"
                  placeholder=""
                  class="p-column-filter"
                />
              </th>
              <th>
                <p-select
                  #licenseMonthDropdown
                  [options]="months"
                  appendTo="body"
                  [(ngModel)]="licenseMonthFilter"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onLicenseMonthChanged($event)"

                  styleClass="p-column-filter"
                  placeholder=""
                  [showClear]="true"
                >
                  <ng-template let-month pTemplate="item">
                    {{ month.label | translate }}
                  </ng-template>
                </p-select>
              </th>
              <th>
              </th>
              <th>
                <p-select
                  width="100%"
                  [options]="statuses"
                  appendTo="body"
                  [(ngModel)]="statusFilter"
                  [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="onStatusChanged($event)"
                  styleClass="p-column-filter"
                  placeholder=""
                  [showClear]="true"
                >
                  <ng-template let-status pTemplate="item">
                    {{ status.label | translate }}
                  </ng-template>
                </p-select>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
            </tr>
          </ng-template>
          <!-- Empty message -->
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td colspan="12">
                {{ "NO_RECORDS_FOUND" | translate }}
              </td>
            </tr>
          </ng-template>
          <!-- Body Content -->
          <ng-template pTemplate="body" let-business>
            <tr>
              <td class="business-navigation">
                <!-- Checks application id, should only appear in IK, BA and Ahlsell, and never in portals -->
                <a
                  *ngIf="
                    !isPortal &&
                    isRModeEnabledApp
                  "
                  href="javascript:void(0)"
                  class="btn btn-outline-primary"
                  (click)="cMode(business)"
                >
                  <span translate>CRM</span>
                </a>
                <a
                  href="javascript:void(0)"
                  class="btn btn-outline-primary"
                  (click)="rModeCheckFeature(business)"
                >
                  <span translate>R</span>
                </a>
              </td>

              <td>
                <span
                  translate
                  pTooltip="{{ business.CompanyName }}"
                  tooltipPosition="top"
                  >{{ business.CompanyName }}</span
                >
              </td>
              <td>
                <span
                  translate
                  pTooltip="{{ business.Connectedto }}"
                  tooltipPosition="top"
                  >{{ business.Connectedto }}</span
                >
              </td>
              <td>
                <span
                  translate
                  pTooltip="{{ business.CategoryName }}"
                  tooltipPosition="top"
                  >{{ business.CategoryName }}</span
                >
              </td>
              <td>
                <span translate>{{
                  business.LicenseMonth | month | translate
                }}</span>
              </td>
              <td style="text-align: center">
                <span style="display: inline-block">
                  {{
                    business.EmployeeCount === 0 ? "-" : business.EmployeeCount
                  }}
                </span>
              </td>

              <td>
                <a
                  href="javascript:void(0)"
                  (click)="editStatus(business.Id, business.Status)"
                  routerLinkActive="active"
                >
                  <span translate>
                    {{ business.Status | rowStatus | translate }}</span
                  >
                </a>
              </td>
              <td>
                <span>{{ business.CreatedOn | date : "dd/MM/yyyy" }}</span>
              </td>
              <td>
                <span>{{ business.ModifiedOn | date : "dd/MM/yyyy" }}</span>
              </td>
              <td>
                <span *ngIf="business.LoginCount != 0">{{
                  business.LoginDate | date : "dd/MM/yyyy"
                }}</span>
              </td>
              <td style="text-align: center">
                <span style="display: inline-block">
                  {{ business.LoginCount === 0 ? "-" : business.LoginCount }}
                </span>
              </td>

              <td class="col-button">
                <button
                  type="button"
                  [routerLink]="['./edit', business.Id, 'details']"
                  title="{{ 'EDIT' | translate }}"
            [attr.aria-label]="'EDIT' | translate" class="kuba-icon-btn kuba-icon-btn--ghost kuba-icon-btn--row">
            <i class="pi pi-pencil"></i>
          </button>
                <button
                  type="button"
                  (click)="confirm(business.Id, business)"
                  title="{{ 'DELETE' | translate }}"
            [attr.aria-label]="'DELETE' | translate" class="kuba-icon-btn kuba-icon-btn--danger kuba-icon-btn--row">
            <i class="pi pi-trash"></i>
          </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
        <!-- Table ends -->
      </div>
    </div>
  </div>
</div>

<kuba-busy [busy]="loading" message="PROCESSING"></kuba-busy>

<p-confirmDialog
  header="{{ 'CONFIRMATION' | translate }}"
  width="425"
  acceptLabel="{{ 'SWITCH_YES' | translate }}"
  rejectLabel="{{ 'SWITCH_NO' | translate }}"
></p-confirmDialog>
